var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5954 12.0606L14.8484 20.3063C14.8484 20.3063 14.8648 20.356 14.8757 20.3835C14.9519 20.6595 15.3061 22.2546 14.3199 24.7547C13.3336 27.2549 10.3639 35.3957 9.59562 37.5041C9.48664 37.8021 9.20329 38.0008 8.8927 38.0008H0.697467C0.697467 38.0008 -0.392325 38.0008 0.152571 36.897C2.33215 31.3778 2.87705 29.722 2.87705 29.722L9.40491 12.6401C9.40491 12.6401 9.4158 12.607 9.42125 12.5905C9.51388 12.2759 10.5546 8.89811 11.5954 12.0606Z",
    fill: "#058FF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1594 1.65217L27.6994 36.5901C27.8417 36.9646 28.0637 37.3061 28.3767 37.5649C28.6556 37.7962 29.0369 38 29.5264 38H37.4945C37.4945 38 38.5929 38 37.5514 35.9128C37.5116 35.8357 37.4774 35.7585 37.449 35.6814L32.9413 23.6812L27.2498 8.81159L24.6203 1.69072C24.2845 0.787536 23.4593 0.110145 22.4746 0.0165217C22.3665 0.00550725 22.247 0 22.1275 0H14.7285C14.7285 0 13.5902 0 14.1594 1.65217Z",
    fill: "#058FF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.602b19668b007a657946ab867c346c18.svg";
export { ForwardRef as ReactComponent };